import React from 'react';
import { IMAGES } from '../../../config/images';
// import '../Header/Header.css';

const Header = () => {
  return (
  <> 
    <section id="main" className="flex-column">
      <div id="header" className="flex-row">
        <img 
          className="logoIconH icon" 
          src="/elements/logoW.svg"
          alt="Логотип"
        />

        {/* Навигация для незарегистрированных пользователей */}
        <ul className="navigation flex-row">
          <li><a href="#welcome">О приложении</a></li>
          <li><a href="#locationsAndRoutes">Локации&Маршруты</a></li>
          <li><a href="#recommendations">Рекомендации</a></li>
          <li><a href="#footer">Контакты</a></li>
          {/* <li><a href="/users/registry">Войти</a></li> */}
        </ul>

        <a href="/tags">
          <img 
            id="searchIcon" 
            className="icon" 
            src="/elements/searchIconW.svg"
            alt="Поиск"
          />
        </a>
      </div>
    </section>


    {/* Планшетная и мобильная версия хедера (скрыта на десктопе) */}
      <div className="main-block-header">
        <div className="main-block-logo">
          {/* Использование SVG как изображения */}
          <img 
            src="/elements/logo.svg" 
            alt="Логотип SPB4YOU" 
            style={{ width: '100%', height: '100%' }}
          />
        </div>

        <div className="main-block-header-right">
          <a href="/tags" className="main-block-search-icon">
            {/* Иконка поиска для планшетной версии */}
            <img 
              src="/elements/searchIconB.svg" 
              alt="Поиск" 
            />
          </a>
        
        <div className="main-block-menu">
          {/* Использование SVG как изображения */}
          <img 
            src="/elements/menuBurgerB.svg" 
            alt="Меню" 
            style={{ width: '100%', height: '100%' }}
          />
        </div>
      </div>
      </div>
     </>
  );
};

export default Header;